import backlinkApi from './backlinkNewApi';

export const backlinkAnchorText = backlinkApi.injectEndpoints({
  endpoints: build => ({
    getNumOfAnchorTextsChart: build.query({
      query: body => ({
        url: '/api_backlink/v1/anchor_text/chart/num_of_anchor_texts',
        method: 'POST',
        body: body
      })
    }),
    getAnchorTextCount: build.query({
      query: body => ({
        url: '/api_backlink/v1/anchor_text/',
        method: 'POST',
        body: body
      })
    }),
    getAnchorText: build.mutation({
      query: body => ({
        url: '/api_backlink/v1/anchor_text/',
        method: 'POST',
        body: body
      })
    })
  })
});

export const {
  useGetAnchorTextCountQuery,
  useGetAnchorTextMutation,
  useGetNumOfAnchorTextsChartQuery
} = backlinkAnchorText;
export default backlinkAnchorText;
